import React from "react";

import { useQuery } from "styles/breakpoints";
import { black50 } from "styles/colors";

import { Header } from "layouts/elements/Header";
import { Navigation } from "layouts/elements/Navigation";

export const HeaderLanding = () => {
  const { isTablet } = useQuery();

  return (
    <Header
      justifyContent='space-between'
      boxShadow={isTablet ? "unset" : `0 0.5rem 1.5rem ${black50}`}
    >
      <Navigation />
    </Header>
  );
};
